import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "dropdown-row__subtitle"
}

import { toRefs, ref, watch } from 'vue'
import IconCheck from '@/design-system/assets/icons/IconCheck.vue'

interface EMITS {
  (e: 'onClicked')
  (e: 'onHover', event: MouseEvent, index: number, title: string, subtitle?: string | undefined)
}
interface Props {
  activeIndex: number
  disabled: boolean
  index: number
  lastNavigationWay: string
  selected?: boolean
  subtitle?: string | undefined
  title: string
}

export default /*@__PURE__*/_defineComponent({
  __name: 'DropdownRow',
  props: {
    activeIndex: {},
    disabled: { type: Boolean },
    index: {},
    lastNavigationWay: {},
    selected: { type: Boolean },
    subtitle: {},
    title: {}
  },
  emits: ["onClicked", "onHover"],
  setup(__props: any, { emit: __emit }) {

const emits = __emit
const props = __props
const {
  activeIndex,
  disabled = false,
  index,
  lastNavigationWay,
  selected,
  subtitle,
  title
} = toRefs(props)
const rowRef = ref<HTMLElement | null>(null)
function onHover(event: MouseEvent, index: number, title: string, subtitle?: string | undefined) {
  emits('onHover', event, index, title, subtitle)
}
watch(activeIndex, (newActiveIndex) => {
  if (newActiveIndex === index.value && lastNavigationWay.value !== 'hover')
    rowRef.value?.scrollIntoView({ behavior: 'smooth', block: 'center' })
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "rowRef",
    ref: rowRef,
    class: _normalizeClass(["dropdown-row", { highlight: _unref(activeIndex) === _unref(index), disabled: _unref(disabled) }]),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('onClicked'))),
    onMouseenter: _cache[1] || (_cache[1] = (e) => onHover(e, _unref(index), _unref(title), _unref(subtitle)))
  }, [
    _createElementVNode("p", null, [
      _createTextVNode(_toDisplayString(_unref(title)), 1),
      (_unref(subtitle)?.length)
        ? (_openBlock(), _createElementBlock("span", _hoisted_1, " (" + _toDisplayString(_unref(subtitle)) + ")", 1))
        : _createCommentVNode("", true)
    ]),
    _withDirectives(_createVNode(IconCheck, { class: "dropdown-row__icon" }, null, 512), [
      [_vShow, _unref(selected)]
    ])
  ], 34))
}
}

})